import { render, staticRenderFns } from "./BaseChuiGaki.vue?vue&type=template&id=7f39bfdf&scoped=true&lang=pug"
import script from "./BaseChuiGaki.vue?vue&type=script&lang=ts"
export * from "./BaseChuiGaki.vue?vue&type=script&lang=ts"
import style0 from "./BaseChuiGaki.vue?vue&type=style&index=0&id=7f39bfdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f39bfdf",
  null
  
)

export default component.exports